module.exports = __webpack_public_path__ + "cdb2dfb0779cc3b1803cef3c5671ba39.png";